import { Tabs } from '@mui/material'
import { styled } from '@mui/material/styles'

const AsterTabs = styled(Tabs)(({ theme }) => ({
  root: {},

  '& .MuiTabs-indicator': {
    display: 'none',
    backgroundColor: 'none'
  },

  '& .MuiTabs-flexContainer': {
    overflowX: 'auto'
  }
}))

export default AsterTabs
